import metamask from "./metamask.png";
import walletconnect from "./walletconnect.png";
import trustwallet from "./trustwallet.png";
import ledger from "./ledger.png";

const WalletLogo = {
  MetaMask: metamask,
  WalletConnect: walletconnect,
  TrustWallet: trustwallet,
  Ledger: ledger,
};

export default WalletLogo;
